import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { IconComponent } from '@mitsubishi/shared/ui';

import { DownloadDatasheetComponent } from './download-datasheet.component';

@NgModule({
  declarations: [DownloadDatasheetComponent],
  imports: [CommonModule, IconComponent, MatTooltip, ApmTranslatePipe],
  exports: [DownloadDatasheetComponent],
})
export class DownloadDatasheetModule {}
